<div *ngIf="checkUrlForVisibility()">
  <ng-template #popTemplate>Ti trovi in:
    <div [innerHtml]="checkUrlForHtml()"></div>
  </ng-template>
  <span type="button" [popover]="popTemplate" containerClass="customClass" placement="auto" triggers="mouseenter:mouseleave" class="fa-stack fa-2x scroll-to-top" [ngClass]="{ 'show-scroll': showScroll }" style="right: auto; left:15px">
    <i class="fas fa-circle fa-stack-2x" [ngStyle]="{ 'color': checkUrlForColor() }"></i>
    <i class="fas fa-info fa-stack-1x fa-inverse"></i>
  </span>
</div>
